import Vue from 'vue'
import CA, { computed } from '@vue/composition-api'
Vue.use(CA)

import { reactive } from '@vue/composition-api'
import { routeCurrent } from '@iez/core/router'

const getRoot = name => name.substring(0, name.indexOf(`_`))

export const state = reactive({
  topTabs: [],

  active: computed(() =>
    state.topTabs.filter(({ route }) => getRoot(route.name) === getRoot(routeCurrent.name))
  )
})

export default () => {
  const methods = {
    add: ({ route, name, icon }) => {
      const instance = state.topTabs.find(topTab => topTab.name === name)
      if (instance) {
        return instance
      }

      const instanceNew = { route, name, icon }
      state.topTabs.push(instanceNew)
      return instanceNew
    }
  }

  return {
    state,
    ...methods
  }
}
